<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="Products" title="Products" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list page-subtitle">
                        <div class="row">
                           <div class="col-md-10 d-flex">
                              <span style="font-size: 20px; font-weight: bolder;">Manage Products</span>
                           </div>
                           <div class="col-md-2">
                              <router-link :to="{ name: 'addproduct' }" class="btn btn-primary">Add Product</router-link>
                            
                           </div>
                        </div>
                     </div>

                     <div class="col-md-12 project-list filter-sort">
                        <div class="row">
                           <div class="col-md-9 d-flex">
                              <label class="d-flex listing-length"><span>Show</span>
                                 <select class="form-select" v-model="listing_length" @change="fetchProducts()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                 </select>
                                 <span>entries</span>
                              </label>
                           </div>
                           <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchProducts()"/>
                           </div>
                        </div>
                     </div>

                        <div class="table-responsive product-table">
                           <table class="display" id="basic-1">
                              <thead>
                                 <tr>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Options</th>
                                 </tr>
                              </thead>
                              <tbody v-if="Boolean(products.length)">
                                 <tr v-for="product in products" :key="product.id">
                                    <td><img v-if="product.image" :src="$image_url + product.image" alt="Image" style="width:100px"></td>
                                    <td>{{product.title}}</td>
                                    <td>Rs. {{product.price}}</td>
                                    <td>
                                       
                                       <label v-if="product.status==0">Blocked</label>
                                       <label v-if="product.status==1">Active</label>
                                       <label v-if="product.status==2">Requested</label>
                                       <label v-if="product.status==3">Rejected</label>
                                       <label v-if="product.status==4">Sold</label>
                                       
                                    </td>
                                    <td>
                                       <router-link :to="{name: 'product.show', params: { id: product.id }}" class="btn btn-sm btn-primary mt-2 me-1" >View</router-link>


                                       <a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(product.id)">{{product.clicks}} Clicks <i class="fa fa-angle-double-right"></i></a>

                                       <router-link :to="{name: 'editproduct', params: { id: product.id }}" class="btn btn-sm btn-primary mt-2 me-1" >Edit</router-link>
                                       <a variant="success" class="btn btn-success mt-2 me-1 btn-sm" @click="approveProduct(product)" v-if="product.status==2">Approve</a> 
                                       <a variant="danger" class="btn btn-danger mt-2 me-1 btn-sm" @click="rejectProduct(product)" v-if="product.status==2">Reject</a>
                                       

                                       <a variant="danger" class="btn btn-danger mt-2 me-1 btn-sm" @click="deactivateProduct(product)" v-if="product.status==1">Deactivate</a>
                                       <a variant="success" class="btn btn-success mt-2 me-1 btn-sm" @click="activateProduct(product)" v-if="product.status==0">Activate</a>                                   
                                    </td>
                                 </tr>
                              </tbody>
                              <tbody v-else>
                                 <tr>
                                    <td colspan="7" class="text-center">No data</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>

                        <nav aria-label="Page navigation" class="mt-2">                    
                           <ul class="pagination">
                              <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                                 <a class="page-link" href="#" @click.prevent="fetchProducts(page.url + '&limit='+ listing_length + '&keyword=' + keyword )" tabindex="-1">
                                    <span v-if="index == 0">Prev</span>
                                    <span v-else-if="index == pagination.length-1">Next</span>
                                    <span v-else>{{page.label}}</span>
                                 </a>
                              </li>                        
                           </ul>
                        </nav>

                  </div>
               </div>
            </div>
         </div>
      </div>


     
  </div>
</template>


<script>
export default {
   name:'View Products',
   data() {
      return {
         products: [],        
         pagination: {},
         
         edit: false,
         product_status: {
            id: "",
            status: ""
         },
         keyword: '',
         listing_length: 10,
         
         token: '',
         errors: {},
         active_page_url: null,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchProducts();

   },

   methods: {      

      fetchProducts(page_url=null) {
         let url = '/api/admin/products?limit=' + this.listing_length + '&keyword=' + this.keyword;
         page_url = page_url || url;  

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
                        
            localStorage.removeItem('back_url');
         }    
         
         this.active_page_url = page_url;   
         this.getToken();
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
               this.products = responseData.data;               
               this.pagination = responseData.links
               console.log(this.products);
            })
            .catch(err => console.log(err));
      },    

      

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      setBackURL(product_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'products.clicks', params: { id: product_id } });
      },

      approveProduct(product) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to approve this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.product_status.id = product.id;
                  this.product_status.status = '1';
                  this.updateProductStatus(1);
					}
					
				});
      },
      rejectProduct(product) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to reject this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                  this.product_status.id = product.id;
                  this.product_status.status = '3';
                  this.updateProductStatus(1);
					}
				});
      },
      activateProduct(product) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.product_status.id = product.id;
                  this.product_status.status = '1';
                  this.updateProductStatus();
					}
					
				});
      },
      deactivateProduct(product) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                  this.product_status.id = product.id;
                  this.product_status.status = '0';
                  this.updateProductStatus();
					}
				});
      },

      updateProductStatus(approval) {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         if(approval) {
            url = '/api/admin/products/approve?product_id=';
         } else {
            url = '/api/admin/products/status?product_id=';
         }
         this.$axios
         .get(url + this.product_status.id + '&status=' + this.product_status.status, config)
         .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               this.fetchProducts(this.active_page_url);
         })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          });
      },
   }   
}
</script>